import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WifiDisabledFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M16.86 5.36L8.02 15.12L2 8.3C4.82 5.84 8.42 4.54 12 4.54C13.64 4.54 15.28 4.82 16.86 5.36ZM18.64 6.08C19.84 6.66 20.98 7.4 22 8.3L12 19.6L9.24 16.46L18.64 6.08Z" />
    </SvgIcon>
  );
});
